import cx from "clsx"
import { getStageColor } from "../../../utils/stageColors.js"
import { Tooltip } from "../../common"
import styles from "./index.module.less"

const StatusTag = ({ data, children, className, style, ...rest }) => {
  return (
    data && (
      <Tooltip title={data?.tooltipContent}>
        <div
          className={cx(className, styles.status)}
          style={{
            "--status-bg-color": data?.color || getStageColor(data?.key),
            ...(data?.textColor && { "--text-color": data?.textColor }),
            ...style,
          }}
          {...rest}
        >
          {children || data.title || data.name}
        </div>
      </Tooltip>
    )
  )
}

export default StatusTag
